var _excluded = ["start"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { Node, mergeAttributes, Mark, getMarkAttributes, wrappingInputRule } from '@tiptap/core';
var ListItem = Node.create({
  name: 'listItem',
  addOptions: function addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: 'bulletList',
      orderedListTypeName: 'orderedList'
    };
  },
  content: 'paragraph block*',
  defining: true,
  parseHTML: function parseHTML() {
    return [{
      tag: 'li'
    }];
  },
  renderHTML: function renderHTML(_ref) {
    var HTMLAttributes = _ref.HTMLAttributes;
    return ['li', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addKeyboardShortcuts: function addKeyboardShortcuts() {
    var _this = this;

    return {
      Enter: function Enter() {
        return _this.editor.commands.splitListItem(_this.name);
      },
      Tab: function Tab() {
        return _this.editor.commands.sinkListItem(_this.name);
      },
      'Shift-Tab': function ShiftTab() {
        return _this.editor.commands.liftListItem(_this.name);
      }
    };
  }
});
var TextStyle = Mark.create({
  name: 'textStyle',
  addOptions: function addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML: function parseHTML() {
    return [{
      tag: 'span',
      getAttrs: function getAttrs(element) {
        var hasStyles = element.hasAttribute('style');

        if (!hasStyles) {
          return false;
        }

        return {};
      }
    }];
  },
  renderHTML: function renderHTML(_ref2) {
    var HTMLAttributes = _ref2.HTMLAttributes;
    return ['span', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands: function addCommands() {
    var _this2 = this;

    return {
      removeEmptyTextStyle: function removeEmptyTextStyle() {
        return function (_ref3) {
          var state = _ref3.state,
              commands = _ref3.commands;
          var attributes = getMarkAttributes(state, _this2.type);
          var hasStyles = Object.entries(attributes).some(function (_ref4) {
            var _ref5 = _slicedToArray(_ref4, 2),
                value = _ref5[1];

            return !!value;
          });

          if (hasStyles) {
            return true;
          }

          return commands.unsetMark(_this2.name);
        };
      }
    };
  }
});
var inputRegex = /^(\d+)\.\s$/;
var OrderedList = Node.create({
  name: 'orderedList',
  addOptions: function addOptions() {
    return {
      itemTypeName: 'listItem',
      HTMLAttributes: {},
      keepMarks: false,
      keepAttributes: false
    };
  },
  group: 'block list',
  content: function content() {
    return "".concat(this.options.itemTypeName, "+");
  },
  addAttributes: function addAttributes() {
    return {
      start: {
        default: 1,
        parseHTML: function parseHTML(element) {
          return element.hasAttribute('start') ? parseInt(element.getAttribute('start') || '', 10) : 1;
        }
      }
    };
  },
  parseHTML: function parseHTML() {
    return [{
      tag: 'ol'
    }];
  },
  renderHTML: function renderHTML(_ref6) {
    var HTMLAttributes = _ref6.HTMLAttributes;

    var start = HTMLAttributes.start,
        attributesWithoutStart = _objectWithoutProperties(HTMLAttributes, _excluded);

    return start === 1 ? ['ol', mergeAttributes(this.options.HTMLAttributes, attributesWithoutStart), 0] : ['ol', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands: function addCommands() {
    var _this3 = this;

    return {
      toggleOrderedList: function toggleOrderedList() {
        return function (_ref7) {
          var commands = _ref7.commands,
              chain = _ref7.chain;

          if (_this3.options.keepAttributes) {
            return chain().toggleList(_this3.name, _this3.options.itemTypeName, _this3.options.keepMarks).updateAttributes(ListItem.name, _this3.editor.getAttributes(TextStyle.name)).run();
          }

          return commands.toggleList(_this3.name, _this3.options.itemTypeName, _this3.options.keepMarks);
        };
      }
    };
  },
  addKeyboardShortcuts: function addKeyboardShortcuts() {
    var _this4 = this;

    return {
      'Mod-Shift-7': function ModShift7() {
        return _this4.editor.commands.toggleOrderedList();
      }
    };
  },
  addInputRules: function addInputRules() {
    var _this5 = this;

    var inputRule = wrappingInputRule({
      find: inputRegex,
      type: this.type,
      getAttributes: function getAttributes(match) {
        return {
          start: +match[1]
        };
      },
      joinPredicate: function joinPredicate(match, node) {
        return node.childCount + node.attrs.start === +match[1];
      }
    });

    if (this.options.keepMarks || this.options.keepAttributes) {
      inputRule = wrappingInputRule({
        find: inputRegex,
        type: this.type,
        keepMarks: this.options.keepMarks,
        keepAttributes: this.options.keepAttributes,
        getAttributes: function getAttributes(match) {
          return _objectSpread({
            start: +match[1]
          }, _this5.editor.getAttributes(TextStyle.name));
        },
        joinPredicate: function joinPredicate(match, node) {
          return node.childCount + node.attrs.start === +match[1];
        },
        editor: this.editor
      });
    }

    return [inputRule];
  }
});
export { OrderedList, OrderedList as default, inputRegex };